export const colors = {
  primary: '#0272ce',
  'primary-disabled': '#bebebe',

  'text-primary': '#4d4f5c',

  error: '#ff0000',

  bg: {
    0: '#fff',
    100: '#f3f3f3',
    200: '#eeeef0',
    300: '#dddddd',
    400: '#cfcfcf',
    500: '#979797',
    600: '#707070',
    800: '#3e3e3e',
  },
};
